import lang from '@/lang/middleware/pages/press';

export default ({ store }) => {
  store.$i18n.mergeLocaleMessage('en', lang.en);
  const description = store.$i18n.t('description');
  const title = store.$i18n.t('title');
  const list = store.$i18n.t('jumbotron.list');
  store.commit('jumbotron/SET_JUMBOTRON', { list, title, type: 'generic' });
  store.commit('pageContent/setHead', { description, title });
};
